/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMaxIcon24Regular = forwardRef('UiFrameSizeMaxIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.25 3a.75.75 0 0 1 .75-.75h3A3.75 3.75 0 0 1 21.75 6v3a.75.75 0 0 1-1.5 0V6A2.25 2.25 0 0 0 18 3.75h-3a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M3.75 15a.75.75 0 0 0-1.5 0v3A3.75 3.75 0 0 0 6 21.75h3a.75.75 0 0 0 0-1.5H6A2.25 2.25 0 0 1 3.75 18v-3Z" }),
        React.createElement("path", { d: "M21.75 15a.75.75 0 0 0-1.5 0v3A2.25 2.25 0 0 1 18 20.25h-3a.75.75 0 0 0 0 1.5h3A3.75 3.75 0 0 0 21.75 18v-3Z" }),
        React.createElement("path", { d: "M6 2.25A3.75 3.75 0 0 0 2.25 6v3a.75.75 0 0 0 1.5 0V6A2.25 2.25 0 0 1 6 3.75h3a.75.75 0 0 0 0-1.5H6Z" })));
});
